package de.oevbs.kunde.kundenportal2.services.lifeValueNotification.store

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification.LifeContract
import de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification.LifeValueClientDefinition
import de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification.LifeValueNotification
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.sfaServiceOrigin
import de.oevbs.sfa.communication.use
import dev.fritz2.core.Handler
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import io.ktor.client.*
import io.ktor.client.engine.js.*
import kotlinx.browser.window
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class LifeValueStore(job: Job) : ValidatingStore<LifeValueNotification, Unit, ComponentValidationMessage>(
    initialData = LifeValueNotification(),
    validation = LifeValueNotification.validation,
    validateAfterUpdate = false,
    metadataDefault = Unit,
    job = job
) {
    private val client = object : LifeValueClientDefinition(window.location.sfaServiceOrigin) {
        override val client: HttpClient = HttpClient(Js, config)
    }.use(PortalSessionMiddleware)

    private val progressStore = storeOf(GeneralProgressStep.SUBMIT1, job)
    val currentStep: Flow<GeneralProgressStep> = progressStore.data

    private val initFailedStore = storeOf(false, Job())
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    val init: Handler<Unit> = handle { currentModel ->
        GlobalServiceMessagesStore.clear()
        globalInitTracker.track {
            val initData = initLifeContracts()
            if (initData == null) {
                initFailedStore.update(true)
                return@track currentModel
            }
            initData
        }
    }

    val requestValueNotification: Handler<Unit> = handle { currentModel ->
        GlobalServiceMessagesStore.clear()

        if (!validate(currentModel).valid) {
            return@handle currentModel
        }

        globalSubmitTracker.track {
            if (requestValueNotification(currentModel.selectedContracts)) {
                progressStore.update(GeneralProgressStep.SUCCESS2)
            }
        }

        // Das Datenmodell wird noch für die Anzeige der Erfolgsmeldung benötigt
        currentModel
    }

    private suspend fun requestValueNotification(contracts: List<LifeContract>): Boolean {
        tryCatchAndHandleErrors("Anfordern einer Wertstandsmitteilung") {
            client.requestNotifications(contracts)
        } ?: return false

        return true
    }

    private suspend fun initLifeContracts(): LifeValueNotification? {
        return tryCatchAndHandleErrors("Initialisieren der Wertstandsmitteilungen") {
            client.init()
        }
    }
}